import { graphql, Link } from "gatsby";
import React from "react";
import { MainHeading } from "../components/MainHeading";
import { Page } from "../components/Page";
import { Thumbnail } from "../components/Thumbnail";
import { ThumbnailGrid } from "../components/ThumbnailGrid";

type GalleriesPageProps = {
  data: GatsbyTypes.GalleriesQuery;
};

export default function GalleriesPage({ data }: GalleriesPageProps) {
  return (
    <Page title="Fotos">
      <div className="prose max-w-none mb-8">
        <p>
          Hier findet Ihr Fotos aus der langen und bunten Geschichte der Band.
          Verschiedenste Konzerte, die sagenumwobenen Morsbach-Fahrten, Plakate,
          CD-Produktionen und mehr rufen hoffentlich auch bei Euch eine ganze
          Menge Erinnerungen an jede Menge Musik, das ein oder andere Knoorz und
          viel, viel Spass zurück.
        </p>
        <p>
          Wir bitten um Rückmeldung, falls Ihr Fotos von Fahrten oder Konzerten
          besitzt, die hier nicht dargestellt sind (siehe Kontakt). Dann können
          wir die Galerie nach und nach ergänzen.
        </p>
      </div>
      {data.allGalleriesJson.group.map((category) => (
        <div key={category.fieldValue} className="mb-8">
          <MainHeading>{category.fieldValue}</MainHeading>
          <ThumbnailGrid>
            {category.nodes.map(
              (gallery) =>
                gallery.fields?.slug &&
                gallery.thumb?.childImageSharp?.gatsbyImageData && (
                  <Link to={gallery.fields.slug} key={gallery.id}>
                    <Thumbnail
                      imageData={gallery.thumb.childImageSharp.gatsbyImageData}
                      alt=""
                      title={gallery.name}
                    />
                  </Link>
                )
            )}
          </ThumbnailGrid>
        </div>
      ))}
    </Page>
  );
}

export const query = graphql`
  query Galleries {
    allGalleriesJson(sort: { fields: [date], order: ASC }) {
      group(field: category) {
        fieldValue
        nodes {
          id
          name
          thumb {
            publicURL
            childImageSharp {
              gatsbyImageData(aspectRatio: 1, width: 590, placeholder: NONE)
            }
          }
          fields {
            slug
          }
        }
      }
    }
  }
`;
